export default { ...process.env, ...window['env'] }